import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense, ReactNode } from 'react';

import './setup/i18n/i18n';
import Layout from 'src/layouts/Layout';
import SndLayout from 'src/layouts/SndLayout';
import { Home } from 'src/pages';
import { Page404 } from 'src/components';
import LoadingPage from './pages/loading/Loading';

// Lazy-loaded components
const lazyPages = {

	About: lazy(() => import('src/pages/about/About')),
	Services: lazy(() => import('src/pages/services/Services')),
	Contact: lazy(() => import('src/pages/contact/Contact')),
	Privacy: lazy(() => import('src/pages/privacy/Privacy')),
	ED: lazy(() => import('src/pages/electronicDiagnostics/ElectronicDiagnostics')),
};

// Types for route configuration
interface RouteConfig {
	path: string;
	element: ReactNode;
}

interface LayoutRouteConfig {
	path: string;
	layout: React.ComponentType;
	routes: RouteConfig[];
}

// Route configuration
const routesConfig: LayoutRouteConfig[] = [
	{
		path: '/',
		layout: Layout,
		routes: [
			{ path: '', element: <Home /> },
			{ path: 'services', element: <lazyPages.Services /> },
			{ path: 'about', element: <lazyPages.About /> },
			{ path: 'privacy', element: <lazyPages.Privacy /> },
			{ path: 'electronic-advanced-system', element: <lazyPages.ED /> },
		],
	},
	{
		path: '/',
		layout: SndLayout,
		routes: [
			{ path: 'contact', element: <lazyPages.Contact /> },
		],
	},
];

const App: React.FC = () => {
	return (
		<Routes>
			{routesConfig.map(({ path: layoutPath, layout: LayoutComponent, routes }) => (
				<Route key={layoutPath} path={layoutPath} element={<LayoutComponent />}>
					{routes.map(({ path, element }) => (
						<Route
							key={path || 'index'}
							path={path}
							element={
								<Suspense fallback={<LoadingPage />}>
									{element}
								</Suspense>
							}
						/>
					))}
				</Route>
			))}
			<Route path="*" element={<Page404 />} />
		</Routes>
	);
};

export default App;
